import React, { useState, useEffect, useContext } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { UserContext } from "shared/context/UserContext";
import { UserTypes } from "shared/constants/UserTypes";

export default function TparActiveForm(props) {
  const {
    handleGenerateReports,
    handleUnsuppressAccount,
    handleDeleteReports,
    inputStartDate = null,
    inputEndDate = null,
    gridData = null,
    isParentSuppressed = false,
  } = props;

  const userContext = useContext(UserContext);

  const [startDate, setStartDate] = useState(inputStartDate);
  const [endDate, setEndDate] = useState(inputEndDate);

  const [isGenerateReportsButtonEnabled, setIsGenerateReportsButtonEnabled] =
    useState(false);
  const [
    isUnsuppressAccountButtonEnabled,
    setIsUnsuppressAccountButtonEnabled,
  ] = useState(false);
  const [isDeleteReportsButtonEnabled, setIsDeleteReportsButtonEnabled] =
    useState(false);

  // Update startDate whenever inputStartDate prop changes (e.g., when switching organizations)
  useEffect(() => {
    if (inputStartDate) {
      setStartDate(inputStartDate);
    }
  }, [inputStartDate]);

  function validateForm() {
    if (!startDate) {
      return "Start Date is a required field.";
    }
    if (!endDate) {
      return "End Date is a required field.";
    }
    if (startDate > endDate) {
      return "Start date cannot be greater than end date.";
    }
    return null;
  }

  function handleGenerateReportsClick(e) {
    e.preventDefault();

    const validationError = validateForm();
    if (validationError) {
      alert(validationError);
      return;
    }

    const formData = {
      startDate: startDate,
      endDate: endDate,
      userName: userContext.email || "",
    };

    if (handleGenerateReports) {
      handleGenerateReports(formData);
    }
  }

  function handleUnsuppressAccountClick(e) {
    e.preventDefault();

    if (handleUnsuppressAccount) {
      handleUnsuppressAccount();
    }
  }

  function handleDeleteReportsClick(e) {
    e.preventDefault();

    if (handleDeleteReports) {
      handleDeleteReports();
    }
  }

  useEffect(() => {
    // //NOTE TODO: Determine if the parent company is unsuppressed, if it is then "setIsUnsuppressAccountButtonEnabled(false)"
    // if(isParentSuppressed){
    //     setIsUnsuppressAccountButtonEnabled(false);
    // }

    if (gridData && Array.isArray(gridData) && gridData.length === 0) {
      let currentDayOfMonth = new Date().getDate();
      if (currentDayOfMonth >= 2) {
        setIsGenerateReportsButtonEnabled(true);
      }
      setIsUnsuppressAccountButtonEnabled(false);
      setIsDeleteReportsButtonEnabled(false);
    } else if (gridData && Array.isArray(gridData) && gridData.length > 0) {
      setIsGenerateReportsButtonEnabled(false);
      let latestEndDate = new Date(
        Math.max(...gridData.map((item) => new Date(item.endDate))),
      );
      // Add 1 day to the latest end date to get the next start date
      let nextStartDate = new Date(latestEndDate);
      nextStartDate.setDate(nextStartDate.getDate() + 1);

      // Only update startDate if it's actually different to prevent infinite loop
      if (!startDate || startDate.getTime() !== nextStartDate.getTime()) {
        setStartDate(nextStartDate);
      }

      //NOTE: If all gridData values have status "Completed", enable the Unsuppress Account button
      let allCompleted = true;
      for (let i = 0; i < gridData.length; i++) {
        if (gridData[i].reportStatus !== "Completed") {
          allCompleted = false;
          break;
        }
      }
      if (!isParentSuppressed) {
        setIsUnsuppressAccountButtonEnabled(false);
      } else {
        setIsUnsuppressAccountButtonEnabled(allCompleted);
      }

      // Enable Delete Reports button only if user has UCT role and there are reports in the grid
      const isUCTUser = userContext.contactType === UserTypes.UCT;
      setIsDeleteReportsButtonEnabled(isUCTUser);
    }
  }, [gridData, isParentSuppressed, userContext.contactType]);

  return (
    <Form>
      <Row>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Start Date</Form.Label>
          <Form.Control
            name="startDate"
            as={DatePicker}
            selected={startDate}
            onChange={(date) => {
              setStartDate(date);
            }}
            placeholder="Select Start Date"
          />
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>End Date</Form.Label>
          <Form.Control
            name="endDate"
            as={DatePicker}
            selected={endDate}
            onChange={(date) => {
              setEndDate(date);
            }}
            placeholder="Select End Date"
          />
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>&nbsp;</Form.Label>
          <Button
            variant={isGenerateReportsButtonEnabled ? "primary" : "secondary"}
            onClick={handleGenerateReportsClick}
            disabled={!isGenerateReportsButtonEnabled}
          >
            Generate Reports
          </Button>
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>&nbsp;</Form.Label>
          <Button
            variant={isUnsuppressAccountButtonEnabled ? "primary" : "secondary"}
            onClick={handleUnsuppressAccountClick}
            disabled={!isUnsuppressAccountButtonEnabled}
          >
            Unsuppress Account
          </Button>
        </Col>
        {isParentSuppressed &&
          userContext.contactType === UserTypes.UCT &&
          gridData &&
          gridData.some(
            (item) =>
              item.reportStatus &&
              item.reportStatus.toLowerCase() === "completed",
          ) && (
            <Col md="auto" className="d-flex flex-column">
              <Form.Label>&nbsp;</Form.Label>
              <Button
                variant={isDeleteReportsButtonEnabled ? "danger" : "secondary"}
                onClick={handleDeleteReportsClick}
                disabled={!isDeleteReportsButtonEnabled}
              >
                Delete Reports
              </Button>
            </Col>
          )}
      </Row>
      {!isUnsuppressAccountButtonEnabled ? (
        <Row>
          <Col md="auto" className="d-flex flex-column">
            <strong style={{ color: "red" }}>
              Data loading process cannot be resumed until reports have
              generated. Please generate reports to activate the "Unsuppress
              Account" button, and review reports prior to selecting. IMPORTANT:
              This action cannot be undone.
            </strong>
          </Col>
        </Row>
      ) : null}
    </Form>
  );
}
